import React, { useContext } from 'react';

interface NeoWrapperContextValue {
  isOpen: boolean;
  closeDrawer: () => void;
  toggleDrawer: () => void;
}

const NeoWrapperDrawerContext = React.createContext<NeoWrapperContextValue>({
  isOpen: false,
  closeDrawer: () => { },
  toggleDrawer: () => { }
});

export const useNeoWrapperDrawerContext = (): NeoWrapperContextValue => {
  const context = useContext(NeoWrapperDrawerContext);
  return context;
};

export default NeoWrapperDrawerContext;
